export type RefinementListItem = {
  value: string | number | boolean;
  label: string;
  count: number;
  isRefined: boolean;
};

export type NumericListItem = {
  value: { start?: number; end?: number };
  label: string;
  isRefined: boolean;
};

export type Bucket = {
  key: string | number | boolean;
  key_as_string: string;
  doc_count: number;
};

export enum SORT_ORDER {
  _ASC = 'asc',
  _DESC = 'desc',
}

export type SortFilterItem = {
  field: string;
  order: SORT_ORDER;
};

export type SortingListItem = {
  label: string;
  value: SortFilterItem;
};
